import { Theme } from '@cambridgeassessment/cambridge-ui';
import { makeStyles } from '@material-ui/core';
import { common } from '@material-ui/core/colors';

export const useStyles = makeStyles((theme: Theme) => ({
  modalWindow: {
    '&>*:nth-child(3)': {
      '&>*:nth-child(1)': {
        width: '550px!important',
        height: '440px!important',
      },
    },
  },
  uploadAvatar: {
    backgroundColor: common['white'],
    color: theme.palette.getContrastText(common['white']),
  },
  zoneContent: {
    border: '3px dashed grey',
  },
  linearProgress: {
    width: '100%',
  },
  modalContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 300,
  },
  flexGrid: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
